import type { AdvancedCreateFromFileSettings } from '../types';
import { APP_CONSTANTS } from '~/common/explicit-exports';

export const DEFAULT_ADVANCED_SETTINGS: AdvancedCreateFromFileSettings = {
  guideDetail: APP_CONSTANTS.AI_GUIDE_GENERATION_DEFAULTS.guide_detail,
  interactivity: APP_CONSTANTS.AI_GUIDE_GENERATION_DEFAULTS.interactivity,
  additionalPrompt: '',
};

export const VALID_FILE_EXTENSIONS = '.pdf,.docx,.pptx';
